<template>
  <a-modal :title="title"
           v-model="visible"
           width="80%"
           style="top: 20px;"
           @cancel="closeModal"
           :closable="!loading"
           :maskClosable="!loading">
    <template slot="footer">
      <a-button type="link" @click="descargarPlantilla()" :loading="loading">
        Descargar Plantilla
      </a-button>
      <a-checkbox @change="(e) => {notificarme = e.target.checked}" :disabled="loading" :checked="notificarme">
        Notificarme al finalizar
      </a-checkbox>
      <a-button type="primary" @click="uploadFile" :loading="loading">
        {{accion === 'Nuevo' ? 'Iniciar':'Reintentar'}} Proceso
      </a-button>
    </template>
    <a-spin :spinning="loading">
      <a-form-model :model="respuestas" @submit="uploadFile"
                    @submit.native.prevent ref="uploadForm">
        <a-row :gutter="[16,16]" v-if="selectedLoad">
          <a-col :span="24">
            <a-upload
              name="archivo"
              :fileList="fileList"
              :beforeUpload="beforeUpload"
              @change="fileChange">
              <a-button>
                <a-icon type="upload"/>
                Seleccionar Archivo
              </a-button>
            </a-upload>
          </a-col>
          <a-divider>Parámetros Disponibles</a-divider>
          <a-col v-bind="colOptions" v-for="component in selectedLoad.active_params">
            <a-form-model-item :label="component.label" :prop="component.name"
                               :hasFeedback="true"
                               :rules="[{required: component.required, message: `El campo ${component.label} es requerido.`}]">
              <template v-if="component.param_type === 'LOV_SQL'">
                <form-model-dropdown style="width: 100%"
                                     v-model="respuestas[component.name]"
                                     endpoint="dynamic_load_param/sql_lov_param_values"
                                     :cache="false"
                                     :params="{...respuestas, id_param: component.id}">
                </form-model-dropdown>
              </template>
              <a-select v-else-if="component.param_type === 'LOV'"
                        v-model="respuestas[component.name]"
                        style="width: 100%"
                        show-search
                        :filter-option="filterOption"
                        option-filter-prop="children">
                <a-select-option :value="option.value" v-for="option in component.active_items">
                  {{option.label}}
                </a-select-option>
              </a-select>
              <a-input-number v-else-if="component.param_type === 'NUMBER'"
                              v-model="respuestas[component.name]"
                              style="width: 100%">
              </a-input-number>
              <a-date-picker v-else-if="component.param_type === 'DATE'"
                             v-model="respuestas[component.name]"
                             valueFormat="Y-MM-DD"
                             style="width: 100%">
              </a-date-picker>
              <a-input v-else
                       v-model="respuestas[component.name]">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-model-item label="Descripción del Proceso" prop="descripcion"
                               :hasFeedback="true"
                               :rules="[{required: true, message: `El campo descripción es requerido.`}]">
              <a-input v-model="respuestas.descripcion"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-alert message="Notas del proceso" type="info" show-icon v-if="selectedLoad">
          <div slot="description" v-html="selectedLoad.help_html"></div>
        </a-alert>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        accion: 'Nuevo',
        visible: false,
        loading: false,
        selectedLoad: null,
        respuestas: {},
        notificarme: false,
        fileList: [],
        colOptions: {
          xs: 24,
          sm: 6
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      uploadFile () {
        if (this.loading) return
        if (this.fileList.length === 0) {
          Mensajes.error('Error', 'Debe seleccionar un archivo.')
          return
        }
        this.$refs.uploadForm.validate(valid => {
          if (valid) {
            try {
              this.loading = true

              let reqData = new FormData()
              reqData.append('adjunto', this.fileList[0])
              reqData.append('notificar', this.notificarme)
              reqData.append('load_id', this.selectedLoad.id)
              for (let prop in this.respuestas) {
                if (this.respuestas.hasOwnProperty(prop)) {
                  if (!JsUtils.isEmpty(this.respuestas[prop])) {
                    reqData.append(prop, this.respuestas[prop])
                  }
                }
              }
              this.httpClient.getInstance()
                .post('dynamic_loads/ejecutar_cargue', reqData)
                .then(response => {
                  this.$emit('success', response.data.id)
                })
                .catch(error => {
                  Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible cargar el archivo.'))
                })
                .then(() => {
                  this.loading = false
                })
            } catch (e) {
              console.log(e)
            }
          }
        })
      },
      /**
       * @param accion ->
       * @param selectedLoad
       */
      showModal (accion, selectedLoad) {
        this.visible = true
        this.accion = accion
        this.respuestas = {}
        this.selectedLoad = {...selectedLoad}
        this.notificarme = false
      },
      descargarPlantilla () {
        this.loading = true

        this.httpClient.getInstance().post('dynamic_loads/generar_plantilla', {
          load_id: this.selectedLoad.id
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', `plantilla_${this.selectedLoad.name}.xlsx`)
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          this.loading = false
        })
      },
      closeModal () {
        this.visible = false
      },
      beforeUpload (file) { return false },
      fileChange (info) {
        if (info.fileList.length > 0) {
          if (info.file.name.endsWith('xls') || info.file.name.endsWith('xlsx') || info.file.name.endsWith('XLSX')) {
            this.fileList = [info.file]
          } else {
            Mensajes.error('Error', 'Solo se permiten archivos de excel.')
          }
        } else {
          this.fileList = []
        }
      },
      filterOption (valorBuscado, selectOption) {
        return selectOption.componentOptions.children[0].text.toLowerCase().indexOf(valorBuscado.toLowerCase()) >= 0
      }
    },
    computed: {
      title () {
        return `${this.accion} proceso de cargue ${this.selectedLoad && this.selectedLoad.name}`
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/DynamicLoads/DynamicLoadRunModal.vue